import { BorrowerValue } from 'app/models/dto/borrower-value.model';

export class GetQuestions {
	static readonly type = '[FilterQuestion] GetQuestions';
	constructor() {}
}

export class GetUnansweredQuestions {
	static readonly type = '[BorrowerValue] GetUnansweredQuestions';
	constructor(public borrowerId: number) {}
}

export class UpdateAnansweredQuestions {
	static readonly type = '[BorrowerValue] UpdateAnansweredQuestions';
	constructor(public borrowerId: number, public modifiedValue: BorrowerValue | any) {}
}


export class ClearQuestionsStore {
	static readonly type = '[FilterQuestion] ClearQuestions';
	constructor() {}
}
